import React, { useEffect, useRef, useState } from 'react';
import { AgxButton, AgxPortal, Icon_CodeXml, useDialog } from '@urbanx/agx.ui-components2';
import DevCampaignScenarioModal from 'features/elements/BeginCampaign/DevCampaignScenario/DevCampaignScenarioModal';
import IconBubble from './IconBubble';
import './DevMenuButton.scss';

interface MenuPosition {
  top: number;
  right: number;
}

const DevMenuButton = () => {
  const triggerRef = useRef<HTMLDivElement>(null);
  const popoverRef = useRef<HTMLDivElement>(null);
  const [showDevMenu, setShowDevMenu] = useState(false);
  const devCampaignScenarioDialog = useDialog(DevCampaignScenarioModal);
  const [menuPosition, setMenuPosition] = useState<MenuPosition>({
    top: 0,
    right: 0,
  });

  useEffect(() => {
    if (!showDevMenu) return;

    const triggerRect = triggerRef.current?.getBoundingClientRect();
    if (!triggerRect) return;

    setMenuPosition({
      top: triggerRect.bottom + 8,
      right: window.innerWidth - triggerRect.right,
    });
  }, [showDevMenu]);

  useEffect(() => {
    if (!showDevMenu) return;

    const handlePointerDown = (event: MouseEvent) => {
      const target = event.target as Node;
      if (triggerRef.current?.contains(target) || popoverRef.current?.contains(target)) {
        return;
      }

      setShowDevMenu(false);
    };

    document.addEventListener('mousedown', handlePointerDown);

    return () => document.removeEventListener('mousedown', handlePointerDown);
  }, [showDevMenu]);

  return (
    <>
      <div ref={triggerRef} className="devMenuShell">
        <IconBubble
          image={<Icon_CodeXml color="var(--fg-brand-main)" />}
          extraClasses="devIconBubble"
          onClick={() => setShowDevMenu((isOpen) => !isOpen)}
        />
      </div>
      {showDevMenu && (
        <AgxPortal>
          <div
            ref={popoverRef}
            className="devMenuPopover"
            style={{
              top: menuPosition.top,
              right: menuPosition.right,
            }}
          >
            <AgxButton
              id="dev-menu-create-test-campaign"
              text="Create Test Campaign"
              variant="white"
              size="small"
              stretch
              onClick={() => {
                setShowDevMenu(false);
                devCampaignScenarioDialog.open();
              }}
            />
          </div>
        </AgxPortal>
      )}
    </>
  );
};

export default DevMenuButton;
